'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAvailabilityMessageTimeout = exports.default = undefined;

var _reduxActions = require('redux-actions');

var _actionTypes = require('../constants/actionTypes');

var addAvailabilityMessageTimeout = (0, _reduxActions.createAction)(_actionTypes.ADD_AVAILABILITY_MESSAGE_TIMEOUT, function (channel, timeout) {
  return { channel: channel, timeout: timeout };
});

exports.default = addAvailabilityMessageTimeout;
exports.addAvailabilityMessageTimeout = addAvailabilityMessageTimeout;